// extracted by mini-css-extract-plugin
export var orienterLink = "f_F";
export var searchContainer = "f_y";
export var searchDisplayTitleBold = "f_C";
export var searchDisplayTitleRegular = "f_D";
export var searchPageSpacer = "f_B";
export var subtitleContainer = "f_z";